<template>
  <div v-if="livingOption && subsection && property" class="live-property">    
    <main-content
      right-sidebar="true"
    >
      <image-gallery 
        :key="$route.fullPath"
        :autoplay="false" 
        :contain-images="false"
        :images="images" 
        :show-nav="images.length > 1 ? true : false"
      />
      <!-- <div class="live-property__details-pane">
        <ul>
          <li>label: {{ property.label }}</li>
          <li>area m^2: {{ property.msq }}</li>
          <li>value: {{ property.price }}</li>
          <li>status: {{ property.status }}</li>
          <li>view: {{ property.view }}</li>
        </ul>
        <div class="live-property__models">
          <ul
            v-for="model in property.models"
            class="live-property__model"
            :key="model._id"
          >
            <li>{{ model.label }}</li>
            <li>{{ model.type }}</li> 
            <li>{{ model.beds }}</li>
            <li>images:
              <ul>
                <li v-for="path in model.images" :key="path">{{ path }}</li>
              </ul>
            </li>
          </ul>
        </div>
      </div> -->
    </main-content>
    <right-sidebar
      :logo="$store.state.config.sidebarLogo"
      :minimap="livingOption.sidebarMinimap"
      :heading="`${livingOption.label[language.code]} - ${propertyNumber}`"
    >
      <div class="description" slot="description">
        <div class="property__subsection">
          {{ subsection.displayName[language.code] }}
        </div>
        <div v-if="property.price !== 0" class="property__label">
          <template v-if="language.code === 'en'">
            Price
          </template>
          <template v-if="language.code === 'ar'">
            السعر
          </template>
        </div>
        <div v-if="property.price !== 0" class="property__price">
          {{ priceFormatted }}<span class="small">OMR </span><span class="small">+VAT</span>
        </div>
        <template v-if="property.tayseerPrice">
          <div class="property__label">
            PHPP/Tayseer Price
          </div>
          <div class="property__price">
            {{ tayseerPriceFormatted }}<span class="small">OMR </span><span class="small">+VAT</span>
          </div>
        </template>

        <div v-if="isPlotDisplayed" class="property__size-group">
          <div class="property__size-group-wrapper">
            <div class="property__label">
              <template v-if="language.code === 'en'">
                Home Size
              </template>
              <template v-if="language.code === 'ar'">
                مساحة البناء
              </template>
            </div>
            <div class="property__size">
              {{ property.msq }}<span>m<sup>2</sup></span>
            </div>
          </div>
          <div class="property__size-group-wrapper">
            <div class="property__label">
              <template v-if="language.code === 'en'">
                Plot Size
              </template>
              <template v-if="language.code === 'ar'">
                مساحة الأرض
              </template>
            </div>
            <div class="property__size">
              {{ property.plotMsq }}<span>m<sup>2</sup></span>
            </div>
          </div>
        </div>
        
        <div v-if="!isPlotDisplayed" class="property__label">
          Apartment Size
        </div>
        <div v-if="!isPlotDisplayed" class="property__size">
          {{ property.msq }}<span>m<sup>2</sup></span>
        </div>

        <div class="property__label">
          <template v-if="language.code === 'en'">
            View
          </template>
          <template v-if="language.code === 'ar'">
            الإطلالة
          </template>
        </div>
        <div class="property__size">
          <template v-if="language.code === 'en'">
            {{ this.property.view }}
          </template>
          <template v-if="language.code === 'ar'">
            <template v-if="this.property.view === 'Lake'">
              البحيرة
            </template>
            <template v-if="this.property.view === 'Urban'">
              حضرية
            </template>
            <template v-if="this.property.view === 'Park View'">
              حديقة 
            </template>
          </template>
        </div>
        <div v-if="property.models[0].beds" class="property__label">
          <template v-if="language.code === 'en'">
            Features
          </template>
          <template v-if="language.code === 'ar'">
            المميزات
          </template>
        </div>        
        <div v-if="property.models[0].beds" class="property__icon">
          <span><fa fixed-width :icon="['fad', 'bed']"/></span> {{ property.models[0].beds }}
        </div>     
          <!-- 
          <div class="property__icon">
            <span><fa fixed-width :icon="['fad', 'bath']"/></span> 2
          </div>    
          <div class="property__icon">
            <span><fa fixed-width :icon="['fad', 'car']"/></span> 1
          </div>
          -->
        <div class="property__favourites">
          <transition name="fast-fade">
            <div v-if="isFavouriteLimitShowing" class="favourites-warning">You've reached your favourites limit</div>
          </transition>
          <button v-if="!isFavourite" class="btn btn--gold" @click="favourites.length < 12 ? addToFavourites(property._id) : displayFavouritesLimitWarning()">
            <template v-if="language.code === 'en'">
              Add to favourites
            </template>
            <template v-if="language.code === 'ar'">
              إضافة إلى المفضلة
            </template>
          </button>
          <button v-if="isFavourite" class="btn btn--red" @click="removeFromFavourites(property._id)">
            <template v-if="language.code === 'en'">
              Remove from favourites
            </template>
            <template v-if="language.code === 'ar'">
              إزالة من المفضلة          
            </template>
          </button>
          <router-link 
            class="btn btn--blue"
            tag="button"
            to="/live/favourites"
          >
            <template v-if="language.code === 'en'">
              View favourites
            </template>
            <template v-if="language.code === 'ar'">
              عرض الخيارات المفضلة          
            </template>
          </router-link>
        </div>
      </div>
      <template slot="bottom-slot">
        <button class="right-sidebar__back" @click="$router.go(-1)"><fa icon="chevron-left"/>{{ language.code === 'en' ? 'Back' : 'عودة' }}</button>
        <div class="right-sidebar__search"></div>
        <!-- <button class="right-sidebar__search"><fa icon="search"/>Search</button> -->
      </template>
    </right-sidebar>
  </div>  
</template>
<script>
// A subsection either links to properties or other subsections 
import ImageGallery from '@/components/ImageGallery'
import MainContent from '@/components/MainContent'
import RightSidebar from '@/components/RightSidebar'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: { ImageGallery, MainContent, RightSidebar },

  data () {
    return {
      favouritesTimeout: null,
      isFavouriteLimitShowing: false
    }
  },

  computed: {
    ...mapGetters({
      livingOption: 'property/activeLivingOption',
      property: 'property/activeProperty',
      subsection: 'property/activeSubsection',
      favourites: 'favourites/favourites',
      language: 'language'
    }),

    isPlotDisplayed () {
      if (this.property.models[0].type.toLowerCase() === 'villa' || this.property.models[0].type.toLowerCase() === 'townhome' || this.property.models[0].type.toLowerCase() === 'palace') {
        return true
      } else {
        return false
      }
    },

    priceFormatted () {
      return `${this.property.price.toLocaleString()}`
      // let dollarOmanLocale = Intl.NumberFormat('he-HE', { style: 'currency', currency: 'OMR', minimumFractionDigits: 0, maximumFractionDigits: 2 })

      // return dollarOmanLocale.format(this.property.price)
    },

    tayseerPriceFormatted () {
      return `${this.property.tayseerPrice.toLocaleString()}`
      // let dollarOmanLocale = Intl.NumberFormat('he-HE', { style: 'currency', currency: 'OMR', minimumFractionDigits: 0, maximumFractionDigits: 2 })

      // return dollarOmanLocale.format(this.property.tayseerPrice)
    },

    details () {
      return `
        
      `
    },

    images () {
      let images = []
      images.push(...this.property.images, ...this.property.models[0].floorplans, ...this.property.models[0].images)
      return images
    },

    propertyNumber () {
      return this.property.label.substring(this.property.label.indexOf('-') + 1)
    },

    isFavourite () {
      return _.find(this.favourites, favourite => { 
        return favourite.propertyId === this.property._id 
      })
    }
  },

  methods: {
    addToFavourites (propertyId) {
      const data = {
        propertyId: propertyId,
        subsectionId: this.subsection._id,
        livingId: this.livingOption._id
      }
      this.$store.commit('favourites/ADD_TO_FAVOURITES', data)
    },

    displayFavouritesLimitWarning () {
      if (this.favouritesTimeout) {
        clearTimeout(this.favouritesTimeout)
      }

      this.isFavouriteLimitShowing = true
      this.favouritesTimeout = setTimeout(() => {
        this.isFavouriteLimitShowing = false
      }, 3000);
    },

    removeFromFavourites (propertyId) {
      this.$store.commit('favourites/REMOVE_FROM_FAVOURITES', propertyId)
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";

.live-property {
  font-family: $touchscreen-font;

  .ar & {
    font-family: 'GE Dinkum';
  }  

  .description {
    display: flex;
    flex-direction: column;
  }

  .property {
    &__subsection {
      font-size: 1.9rem;
      text-transform: uppercase;
      margin-top: -1.5rem;
      opacity: 0.7;
    }

    &__label {
      // color: $lblue;
      font-size: 1.5rem;
      text-transform: uppercase;
      margin-top: 2.5rem;
      opacity: 0.7;
    }

    &__icon {
      font-size: 3rem;
      margin-top: 1rem;
      span {
        font-size: 2.7rem;
        margin-right: 1rem;
      }
    }

    &__size-group {
      display: flex;
    }

    &__size-group-wrapper {
      margin-right: 2rem;
    }

    &__price, &__size {
      font-size: 2.2rem;

      span {
        font-size: 2rem;
        // opacity: 0.8;
        margin-left: 0.3rem;
      }

      .small {
        font-size: 1.4rem;
      }
    }

    &__favourites {
      margin: auto 0 0;
      position: relative;
      width: 26rem;

      .btn {
        color: $black;
        font-family: $touchscreen-font;
        font-size: 1.4rem;
        margin: 1rem 0 0;
        padding: 1rem 0 .8rem;
        text-transform: uppercase;
        width: 26rem;

        .ar & {
          font-family: 'GE Dinkum';
        }        

        &--gold {
          @include btn($gold, $gold);
        }

        &--red {
          @include btn($red, $red);
          color: $white;
        }

        &--blue {
          @include btn($ddblue, $ddblue);
          color: $white;
        }
      }
    }
  }

  .main-content {
    background-color: #fff;
  }
  
  &__details-pane {
    position: absolute;
    z-index: 9;
    color: black;
    font-size: 3rem;
  }

  &__models {
    display: flex;
    flex-wrap: wrap;
  }

  &__model {

  }
}

.favourites-warning {
  background: rgb(211, 32, 0);
  border-radius: .5rem;
  color: $white;
  display: inline-block;
  font-size: 1.2rem;
  left: 50%;
  padding: .5rem 1rem;
  position: absolute;
  top: -2.1rem;
  transform: translateX(-50%);
  width: max-content;

  &::after {
    border: 1rem solid transparent;
    border-top-color: rgb(211, 32, 0);
    position: absolute;
    content: '';
    left: 50%;
    bottom: -1.5em;
    transform: translateX(-50%);
  }
}
</style>